// extracted by mini-css-extract-plugin
export default {"crosswordModal":"CrosswordModal_crosswordModal__TposZ","body":"CrosswordModal_body__q8rZG"};